"use strict"
var moment = require("moment");
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = moment;



/*****************
 ** WEBPACK FOOTER
 ** ./~/moment-es6/index.js
 ** module id = 108
 ** module chunks = 0
 **/